import React from "react";
import { useTranslation } from "react-i18next";
import { LANGS } from "../lib/i18n";
import { Globe } from "@phosphor-icons/react";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();

  const change = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("locale", lng);
    document.documentElement.lang = lng;
  };

  return (
    <div className={`inline-flex items-center gap-2 ${compact ? "text-xs" : "text-sm"}`} data-testid="language-switcher">
      <Globe size={compact ? 12 : 14} className="text-zinc-500" aria-hidden="true" />
      <label htmlFor="lang-select" className="sr-only">{t("common.language")}</label>
      <select
        id="lang-select"
        value={i18n.language}
        onChange={(e) => change(e.target.value)}
        className={`bg-transparent border-none focus:outline-none ${compact ? "text-xs" : "text-sm"}`}
        aria-label={t("common.language")}
      >
        {LANGS.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </div>
  );
}
